@if (options.length > 0) {
  <div class="container">
    <div class="wre-table-container w-100">
      <div #tableContainer class="table-responsive">
        <table class="table wre-table fixed-column table-hover p-0 m-0">
          <thead class="text-center px-0 pt-2 m-0 d-block">
            <tr class="t-header">
              <th class="text-nowrap col-ellipsis column-users">Value</th>
              <th class="text-nowrap col-ellipsis column-email">Status</th>
            </tr>
          </thead>
          <tbody class="p-0 m-0 table-height">
            @for (item of options; track item; let isLast = $last) {
              <tr class="tr-padding" [ngClass]="{ 'border-bottom': isLast }">
                <td class="text-nowrap col-ellipsis column-users">
                  <span>{{ item.name }}</span>
                </td>
                <td class="text-nowrap col-ellipsis column-email">
                  <wre-toolkit-toggle-switch
                    class=""
                    name="include-paid"
                    #includePaidRef="ngModel"
                    labelText="{{ item.active ? 'Active' : 'Inactive' }}"
                    [(ngModel)]="item.active">
                  </wre-toolkit-toggle-switch>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
} @else {
  <div class="no-users-text px-3 py-3">There are no items.</div>
}
